var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmptyStateGrayscale2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 120,
    viewBox: "0 0 120 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.4304 32.5713C8.00964 32.5713 2.95469 37.6681 3.46382 43.6287L6.41759 78.0045C6.87419 83.3264 11.6463 87.4284 17.3841 87.4284H102.615C108.349 87.4284 113.121 83.3264 113.582 78.0045L116.535 43.6287C117.049 37.6722 111.99 32.5713 105.569 32.5713H14.4304Z",
    fill: "#EBEBEB"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M31.66 33.3347L76.84 25.3675C76.9386 25.3504 77.0372 25.3418 77.1358 25.3418C77.9629 25.3418 78.6658 25.9332 78.8115 26.7475L81.4472 41.6832C81.5243 42.1332 81.4172 42.6047 81.1472 42.9732L77.3072 48.2918C77.0158 48.6989 76.8743 49.2004 76.9086 49.6975L35.8172 56.9447L31.6558 33.3347H31.66Z",
    fill: "#C2C2C2",
    stroke: "#999999",
    strokeWidth: 0.857143
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M46.7457 89.2075C44.7829 89.2075 43.1072 87.8018 42.7643 85.8603L34.0514 36.446C33.6657 34.2475 35.1357 32.1432 37.3343 31.7575L59.77 27.8018L80.1529 42.536L86.4357 78.1632C86.8214 80.3618 85.3515 82.466 83.1529 82.8518L47.4529 89.1432C47.2172 89.186 46.9814 89.2075 46.7457 89.2075Z",
    fill: "#C2C2C2",
    stroke: "#999999",
    strokeWidth: 0.857143
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M66.4986 44.1858C64.6901 44.1858 63.1472 42.8915 62.8301 41.1044L60.5886 28.3887L79.3815 41.9744L67.1501 44.1301C66.9358 44.1687 66.7172 44.1858 66.4986 44.1858Z",
    fill: "#EBEBEB",
    stroke: "#999999",
    strokeWidth: 0.857143
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M39.4815 92.5716C38.6243 92.5716 37.8958 91.9587 37.7501 91.1144L27.6915 34.0844C27.6101 33.6216 27.7129 33.1544 27.9829 32.7687C28.2529 32.383 28.6558 32.1259 29.1229 32.0444L72.1515 24.4544C72.2543 24.4373 72.3572 24.4287 72.4601 24.4287C73.3172 24.4287 74.0458 25.0416 74.1958 25.8859L84.25 82.9159C84.4172 83.8716 83.7786 84.7887 82.8186 84.9601L39.79 92.5459C39.6872 92.563 39.5843 92.5716 39.4815 92.5716Z",
    fill: "#D6D6D6",
    stroke: "#999999",
    strokeWidth: 0.857143
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M76.4689 67.343L58.0165 70.5966C57.478 70.6916 57.1185 71.2051 57.2134 71.7435L59.1097 82.4976C59.2046 83.0361 59.7181 83.3956 60.2565 83.3007L78.709 80.047C79.2475 79.952 79.607 79.4386 79.5121 78.9001L77.6158 68.146C77.5209 67.6076 77.0074 67.248 76.4689 67.343Z",
    fill: "#ADADAD"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M36.7557 95.9614C34.7929 95.9614 33.1172 94.5557 32.7743 92.6142L24.0615 43.2C23.6757 41.0014 25.1457 38.8971 27.3443 38.5114L49.78 34.5557L70.1629 49.2899L76.4457 84.9171C76.6343 85.9799 76.3943 87.0557 75.7772 87.9428C75.1557 88.8299 74.23 89.4171 73.1672 89.6057L37.4672 95.8971C37.2315 95.94 36.9957 95.9571 36.76 95.9571L36.7557 95.9614Z",
    fill: "white",
    stroke: "#999999",
    strokeWidth: 0.857143
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M56.5128 50.9397C54.7042 50.9397 53.1614 49.6454 52.8442 47.8583L50.6028 35.1426L69.3956 48.7283L57.1642 50.884C56.9499 50.9226 56.7314 50.9397 56.5128 50.9397Z",
    fill: "#EBEBEB"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M56.5128 50.9397C54.7042 50.9397 53.1614 49.6454 52.8442 47.8583L50.6028 35.1426L69.3956 48.7283L57.1642 50.884C56.9499 50.9226 56.7314 50.9397 56.5128 50.9397Z",
    stroke: "#999999",
    strokeWidth: 0.857143
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.2,
    style: {
      mixBlendMode: "multiply"
    }
  }, _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M89.8759 55.9285C97.9921 55.9285 104.572 49.349 104.572 41.2328C104.572 33.1166 97.9921 26.5371 89.8759 26.5371C81.7597 26.5371 75.1802 33.1166 75.1802 41.2328C75.1802 49.349 81.7597 55.9285 89.8759 55.9285Z",
    fill: "#7A7A7A"
  }))), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M88.4101 54.4627C96.5263 54.4627 103.106 47.8832 103.106 39.767C103.106 31.6508 96.5263 25.0713 88.4101 25.0713C80.2938 25.0713 73.7144 31.6508 73.7144 39.767C73.7144 47.8832 80.2938 54.4627 88.4101 54.4627Z",
    fill: "#7A7A7A"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M94.6586 33.3126C93.9472 32.6054 92.7858 32.6054 92.0743 33.3126L88.4915 36.874L84.9086 33.3126C84.1972 32.6054 83.0358 32.6054 82.3243 33.3126C81.6129 34.0197 81.6129 35.1769 82.3243 35.884L85.9072 39.4454L82.3243 43.0069C81.6129 43.714 81.6129 44.8712 82.3243 45.5783C83.0358 46.2854 84.1972 46.2854 84.9086 45.5783L88.4915 42.0169L92.0743 45.5783C92.7858 46.2854 93.9472 46.2854 94.6586 45.5783C95.3701 44.8712 95.3701 43.714 94.6586 43.0069L91.0758 39.4454L94.6586 35.884C95.3701 35.1769 95.3701 34.0197 94.6586 33.3126Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyStateGrayscale2);
export default __webpack_public_path__ + "static/media/empty-state-grayscale-2.2f5c6333dd2240a165d3bd5a46bd6cd4.svg";
export { ForwardRef as ReactComponent };